/**
 * @typedef {Object} RippleOptions
 * @property {string?} color リップルの色。指定しない場合は現在のフォントカラー
 * @property {boolean} center リップルをクリック位置ではなく中央から発生させるフラグ
 */

/**
	* リップル部品
	*/
export default class Ripple {
	/** @type {HTMLElement} リップルを表示する要素 */
	#el
	/** @type {RippleOptions} 表示オプション */
	#options = {
		center: false
	}

	/** @type {number} 表示中のリップル数 */
	#count = 0
	#isStatic = false

	/** @type {Function} */
	#eventRemover
	/**
	 *
	 * @param {HTMLElement} el リップルを表示する要素
	 * @param {RippleOptions} options 表示オプション
	 */
	constructor (el, options) {
		this.#el = el
		this.#options = {
			...this.#options,
			...options
		}
	}

	init () {
		const showRipple = (e) => {
			this.#showRipple(e)
		}
		this.#el.addEventListener("mousedown", showRipple, { passive: true })
		this.#el.addEventListener("touchstart", showRipple, { passive: true })
		this.#eventRemover = () => {
			this.#el.removeEventListener("mousedown", showRipple)
			this.#el.removeEventListener("touchstart", showRipple)
		}
	}

	destroy () {
		if (this.#eventRemover) this.#eventRemover()
		this.#eventRemover = null
	}

	/**
	 * @param {MouseEvent} e
	 */
	#showRipple (e) {
		const wrapper = document.createElement("span")
		wrapper.classList.add("ripple-wrapper")
		const ripple = document.createElement("span")
		ripple.classList.add("ripple")
		wrapper.appendChild(ripple)

		const { x, y, radius } = this.#calcPosition(e)

		const diameter = radius * 2
		ripple.style.left = `${x}px`
		ripple.style.top = `${y}px`
		ripple.style.width = `${diameter}px`
		ripple.style.height = `${diameter}px`

		const { color } = this.#options
		if (color && typeof color === "string") {
			ripple.style.backgroundColor = color
		}

		this.#count++

		const computed = window.getComputedStyle(this.#el)
		if (computed && computed.position === "static") {
			console.warn("リップルを表示する対象要素にはposition: relative;を指定してください。", this.#el)
			this.#el.style.position = "relative"
			this.#isStatic = true
		}

		this.#el.appendChild(wrapper)

		// アニメーションが終わったらリップル要素を消す
		setTimeout(() => {
			const remain = --this.#count
			if (!remain && this.#isStatic) {
				delete this.#el.style.position
			}
			this.#el.removeChild(wrapper)
		}, 600) // rippleのanimation durationと同じか少し大きい値を設定する
	}

	/**
	 * @param {MouseEvent} e
	 * @param {boolean} center
	 */
	#calcPosition (e) {
		const { left, top, width, height } = this.#el.getBoundingClientRect()

		if (this.#options.center) {
			const cx = width / 2
			const cy = height / 2
			const radius = Math.sqrt(Math.pow(cx, 2) + Math.pow(cy, 2))
			return { x: cx - radius, y: cy - radius, radius }
		}

		const clickX = e.clientX - left
		const clickY = e.clientY - top

		const progressWidth = width / 2 > clickX ? width - clickX : clickX
		const progressHeight = height / 2 > clickY ? height - clickY : clickY
		const radius = Math.sqrt(Math.pow(progressWidth, 2) + Math.pow(progressHeight, 2))

		const x = clickX - radius
		const y = clickY - radius

		return { x, y, radius }
	}
}
